

<section class='content' *ngIf='current_knowledge'>
  <!--
    <quill-view [content]="current_knowledge.html" format="html">
    </quill-view>
    -->
</section>